import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Loading from 'components/Loading/index';
import Saving from 'components/Saving/index';
import api from 'api';
import Util from 'utility';
import { __ } from 'locale';

import UserEditHelp from 'components/Help/UserEditHelp';

import {
    openModal,
    closeModal,
    showMessage,
} from 'actions/index';

const card = 'bg-white rounded-2xl border border-slate-100 shadow-sm p-6';
const sectionTitle = 'text-base font-semibold text-slate-800 flex items-center gap-2 mb-4';
const fieldRow = 'flex items-start gap-4 py-2';
const fieldLabel = 'w-40 shrink-0 text-sm text-slate-500 pt-2 leading-snug';
const inputCls = 'w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 shadow-sm transition-colors focus:border-green-400 focus:outline-none focus:ring-2 focus:ring-green-100';
const inputShort = 'w-20 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 shadow-sm transition-colors focus:border-green-400 focus:outline-none focus:ring-2 focus:ring-green-100';
const selectCls = 'rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 shadow-sm transition-colors focus:border-green-400 focus:outline-none focus:ring-2 focus:ring-green-100';
const helpBtn = 'inline-flex items-center justify-center w-5 h-5 rounded-full bg-slate-100 border border-slate-200 text-xs text-slate-400 hover:bg-slate-200 hover:text-slate-600 transition-colors cursor-pointer flex-shrink-0';
const checkLabelCls = 'flex items-center gap-2 cursor-pointer text-sm text-slate-700 [&>input]:hidden [&>b]:flex [&>b]:items-center [&>b]:justify-center [&>b]:w-5 [&>b]:h-5 [&>b]:text-xs [&>b]:rounded-full [&>b]:border [&>b]:border-slate-300 [&>b]:flex-shrink-0 [&>b>i]:text-white [&>input:checked~b]:border-green-500 [&>input:checked~b]:bg-green-500 [&:hover>b]:border-green-400';

const nutritionRegimeExcludes = {
    1: [10, 20, 30, 40],
    10: [20, 30, 40, 1, 60],
    20: [10, 30, 40, 1],
    30: [10, 20, 40, 1, 60],
    40: [10, 20, 30, 1, 60],
    50: [],
    60: [10, 30],
    201: [],
};

function UserEdit() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams();
    const { globals } = data;

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [profile, setProfile] = useState({});
    const [account] = useState({});
    const [themes, setThemes] = useState({});
    const [themeFolder, setThemeFolder] = useState('');
    const [vegeRegimesWarning, setVegeRegimesWarning] = useState(false);
    const [tab, setTab] = useState('basic');
    const initialProfileUrl = '';
    const [allowedNutritionRegimes, setAllowedNutritionRegimes] = useState(
        () => Object.keys(globals.eatingRegimes)
    );
    const [newPasswordInputType, setNewPasswordInputType] = useState('password');
    const [changeLoginData, setChangeLoginData] = useState(false);

    useEffect(() => {
        Util.setPageTitle('Uživatel');
        api('profile/get/' + params.id).then(result => {
            let p = result.data;

            const birthday = p.birthday.split('-').map(n => n * 1);
            p.birthday_day = birthday[2];
            p.birthday_month = birthday[1];
            p.birthday_year = birthday[0];

            p.new_password = '';
            p.new_password_confirmation = '';

            let tf = '';
            if (p.theme !== null && p.theme !== '') {
                tf = p.theme.split('/');
                tf = tf[0];
            }

            setProfile(p);
            setThemes(p.themes);
            setThemeFolder(tf);
            setLoading(false);
        });
    }, []); // eslint-disable-line

    const openHelp = (e, help) => {
        const helpTitles = {
            'name': 'Jméno profilu',
            'photo': 'Profilová fotka',
            'inputData': 'Vstupní údaje',
            'bmr': 'Bazální metabolismus',
            'energeticRegime': 'Energetický režim',
            'energyOutput': 'Výdej energie',
            'nutritionRegime': 'Stravovací režimy',
            'color': 'Barva profilu',
            'newPassword': 'Změna hesla',
            'pin': 'PIN',
        };

        dispatch(closeModal());
        dispatch(openModal({
            'title': helpTitles[help] + ' - nápověda',
            'class': 'dialog-flexible',
            'content': UserEditHelp[help](),
        }));
    };

    const onThemeFolderChange = (e) => {
        setThemeFolder(e.target.value);
    };

    const onChange = (e) => {
        const key = e.target.name;
        let value = e.target.value;

        const valueNumeric = value * 1;
        if (value == valueNumeric.toString()) value = valueNumeric;

        if (key === 'photo') {
            value = e.target.files[0];
        }

        if (key === 'eating_regimes[]') {
            const checked = e.target.checked;
            let newRegimes = [...profile.eating_regimes];
            if (checked) {
                newRegimes.push(value);
            } else {
                const i = newRegimes.indexOf(value);
                if (i > -1) newRegimes.splice(i, 1);
            }

            let allowed = Object.keys(globals.eatingRegimes);
            newRegimes.map(r => {
                if (r * 1 == 0) return;
                nutritionRegimeExcludes[r * 1].map(excl => {
                    allowed = allowed.filter(a => a != excl);
                });
            });
            allowed = allowed.map(r => r * 1);
            newRegimes = newRegimes.filter(r => allowed.includes(r * 1));
            if (allowed.length === 0) {
                newRegimes = [];
                allowed = Object.keys(globals.eatingRegimes).map(r => r * 1);
            }

            setAllowedNutritionRegimes(allowed);

            const vegetarianRegimes = [10, 20, 30];
            let numVegeRegimes = 0;
            newRegimes.map(regime => {
                if (vegetarianRegimes.includes(regime * 1)) numVegeRegimes++;
            });
            setVegeRegimesWarning(numVegeRegimes > 1);

            setProfile(prev => ({ ...prev, eating_regimes: newRegimes }));
        } else {
            setProfile(prev => ({ ...prev, [key]: value }));
        }
    };

    const selectActiveTheme = (e, theme) => {
        setProfile(prev => ({ ...prev, theme: themeFolder + '/' + theme }));
    };

    const saveProfile = () => {
        if (profile.new_password !== '') {
            if (profile.new_password !== profile.new_password_confirmation) {
                dispatch(showMessage({ show: true, type: 'error', message: 'Zadaná hesla nejsou stejná.' }));
                return false;
            }
        }

        setSaving(true);

        let fd = new FormData();
        for (let i in profile) {
            fd.append(i, profile[i]);
        }

        api('profile/update/' + params.id, {post: true, data: fd}).then(() => {
            setTimeout(() => {
                setSaving(false);
                history.push('/user/edit/' + Util.getFirstProfileId());
            }, 300);
        });
    };

    const toggleNewPasswordInputType = () => {
        setNewPasswordInputType(prev => prev === 'password' ? 'text' : 'password');
    };

    const changeTab = (t) => {
        setTab(t);
    };

    if (loading) return <Loading />;

    const savingEl = saving ? <Saving /> : false;

    const random = Math.random() * 10000000;

    if (profile.hobbies == 'null') profile.hobbies = '';
    if (profile.favorite_kitchen == 'null') profile.favorite_kitchen = '';

    let profileKeys = [];
    for (let pk in globals.profileKeys) {
        profileKeys.push({id: pk, title: globals.profileKeys[pk]});
    }

    let birthdayDays = [];
    for (let n = 1; n <= 31; n++) birthdayDays.push(n);

    const birthdayMonths = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'];

    let birthdayYears = [];
    for (let n = 1900; n <= (new Date()).getFullYear(); n++) birthdayYears.push(n);

    const profileColors = ['000000', 'dd0000', '00cc00', '0088ee', 'ff7700', 'aa00cc', 'ffcc44', 'ff26f2', '00c97b'];

    const allowed = allowedNutritionRegimes.map(r => r * 1);

    let eatingRegimes = [];
    for (let r in globals.eatingRegimes) {
        const isAllowed = allowed.includes(r * 1);
        eatingRegimes.push(
            <label key={r} className={checkLabelCls + (!isAllowed ? ' opacity-30' : '')}>
                <input disabled={!isAllowed} type="checkbox" name="eating_regimes[]" value={r} checked={profile.eating_regimes.includes(r * 1)} onChange={onChange} />
                <b><i className="fa fa-check"></i></b>
                {globals.eatingRegimes[r].title}
            </label>
        );
    }

    let energyBalanceOptions = [];
    for (let e in globals.energyBalanceOptions) {
        energyBalanceOptions.push(
            <label key={e} className={checkLabelCls}>
                <input type="checkbox" name="energy_balance_option" value={e} checked={profile.energy_balance_option == e} onChange={onChange} />
                <b><i className="fa fa-check"></i></b>
                {globals.energyBalanceOptions[e]}
            </label>
        );
    }

    let themeFolderOptions = [<option key="" value={''}>Vyberte...</option>];
    for (let f in themes) {
        themeFolderOptions.push(
            <option key={f} value={f}>{themes[f].title}</option>
        );
    }

    let themePictures = [];
    if (themeFolder && themeFolder !== '' && themeFolder !== 'null') {
        for (let t in themes[themeFolder].items) {
            const theme = themes[themeFolder].items[t];
            const themePath = themeFolder + '/' + theme;
            const isActive = themePath === profile.theme;
            themePictures.push(
                <div key={t} className="inline-block m-1">
                    <a className={isActive ? 'block ring-2 ring-green-500 rounded overflow-hidden' : 'block rounded overflow-hidden hover:ring-2 hover:ring-slate-300 transition-all'} onClick={(e) => selectActiveTheme(e, theme)}>
                        <div style={{ backgroundImage: `url(https://www.zofapp.cz/data/app/zof/themes/${themeFolder}/${theme}`, width: '80px', height: '50px', backgroundSize: 'cover' }}>
                        </div>
                    </a>
                </div>
            );
        }
    }

    let energyOutputCoefficients = [];
    for (let c in globals.energyOutputCoefficients) {
        const coef = globals.energyOutputCoefficients[c];
        energyOutputCoefficients.push(
            <label key={c} className={checkLabelCls}>
                <input type="radio" name="energy_output_coefficient" value={c} checked={profile.energy_output_coefficient == c} onChange={onChange} />
                <b><i className="fa fa-check"></i></b>
                {coef.title}
            </label>
        );
    }

    let erOptions = {
        'reduction': 'Chci hubnout',
        'balanced': 'Vyrovnaný',
        'gain': 'Chci přibrat',
    };

    if (Util.getLang() === 'sk') {
        erOptions = {
            'reduction': 'Chcem chudnúť',
            'balanced': 'Vyrovnaný',
            'gain': 'Chcem pribrať',
        };
    }

    if (profile.energetic_regime === null) profile.energetic_regime = 'balanced';

    let energeticRegimes = [];
    Object.keys(erOptions).map(r => {
        energeticRegimes.push(
            <label key={r} className={checkLabelCls}>
                <input type="radio" name="energetic_regime" value={r} checked={profile.energetic_regime == r} onChange={onChange} />
                <b><i className="fa fa-check"></i></b>
                {erOptions[r]}
            </label>
        );
    });

    const newPasswordInputIcon = newPasswordInputType === 'text'
        ? <i className="fa fa-eye"></i>
        : <i className="fa fa-eye-slash"></i>;

    const currentProfileUrl = `https://www.zofapp.cz/u/id/${account.id}`;

    let publicProfileInput = (
        <React.Fragment>
            <div className="flex items-center gap-2 flex-1">
                <span className="text-sm text-slate-500 whitespace-nowrap">zofapp.cz/u/</span>
                <input className={inputCls} type="text" name="profile_url" onChange={onChange} value={account.profile_url} maxLength="40" />
            </div>
            <p className="mt-2 text-xs text-slate-500">Pokud si nezadáte vlastní adresu profilu, bude dostupný na adrese <b>{currentProfileUrl}</b>.<br />Upozornění: po zadání adresy již nebude možné ji změnit.</p>
        </React.Fragment>
    );
    if (initialProfileUrl !== null && initialProfileUrl !== '') {
        publicProfileInput = (
            <React.Fragment>
                <div className="flex items-center gap-2 flex-1">
                    <span className="text-sm text-slate-500 whitespace-nowrap">zofapp.cz/u/</span>
                    <input className={inputCls + ' bg-slate-50 text-slate-400 font-medium'} readOnly={true} type="text" name="profile_url" value={initialProfileUrl} maxLength="40" />
                </div>
                <p className="mt-2 text-xs text-slate-500">Chcete změnit adresu Vašeho profilu? <a target="_blank" href="https://www.zofapp.cz/kontakt" className="text-green-600 hover:underline">Napište nám</a>.</p>
            </React.Fragment>
        );
    }

    let content = false;
    if (tab === 'basic') {
        content = (
            <div className="space-y-5">
                {/* Info banner */}
                <div className="flex items-start gap-3 rounded-xl bg-amber-50 border border-amber-200 p-4">
                    <i className="fa fa-info-circle text-amber-500 text-lg mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-amber-800 leading-relaxed">{__('Na základě vyplněných základních údajů může aplikace vyhodnocovat Vaše recepty a jídelníčky, generovat jídelníčky na míru, sledovat energetickou bilanci.')}</p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    {/* Left column */}
                    <div className="space-y-5">
                        {/* Jméno profilu */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-user text-green-500"></i>
                                {__('Jméno profilu')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'name')}>?</a>
                            </h3>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Jméno')}:</span>
                                <input className={inputCls + ' font-semibold'} type="text" name="name" onChange={onChange} value={profile.name} />
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Oslovení')}:</span>
                                <input className={inputCls} type="text" name="salutation" onChange={onChange} value={profile.salutation} />
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Specifikace')}:</span>
                                <select className={selectCls + ' flex-1'} name="persona_key" onChange={onChange} defaultValue={profile.persona_key}>
                                    {profileKeys.map(pk => (
                                        <option key={pk.id} value={pk.id}>{pk.title}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Profilová fotka */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-camera text-green-500"></i>
                                {__('Profilová fotka')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'photo')}>?</a>
                            </h3>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Foto')}:</span>
                                <input className="flex-1 text-sm text-slate-600 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-green-50 file:text-green-700 hover:file:bg-green-100" type="file" name="photo" accept="image/*" onChange={onChange} />
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Stávající foto')}:</span>
                                <img src={`https://www.zofapp.cz/data/zof/profile/${profile.photo_filename}?r=${random}`} className="w-20 h-auto rounded-lg border border-slate-200" alt="" />
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}></span>
                                <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer">
                                    <input type="checkbox" name="delete_photo" checked={profile.delete_photo === true} onChange={onChange} className="rounded border-slate-300" />
                                    Vymazat foto
                                </label>
                            </div>
                        </div>

                        {/* Barva profilu */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-palette text-green-500"></i>
                                {__('Barva profilu')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'color')}>?</a>
                            </h3>
                            <div className="flex flex-wrap gap-2 pt-1">
                                {profileColors.map(color => (
                                    <label key={color} className="cursor-pointer">
                                        <input type="radio" name="profile_color" value={color} checked={profile.profile_color == color} onChange={onChange} className="hidden" />
                                        <span className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm text-white font-medium border-2 transition-all ${profile.profile_color == color ? 'border-slate-600 ring-2 ring-slate-400 ring-offset-1' : 'border-transparent'}`} style={{ backgroundColor: '#' + color }}>
                                            {profile.profile_color == color && <i className="fa fa-check text-xs"></i>}
                                            {profile.name}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* PIN */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-lock text-green-500"></i>
                                PIN
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'pin')}>?</a>
                            </h3>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Váš ZOF PIN')}:</span>
                                <span className="text-2xl font-bold tracking-[0.3em] text-slate-700 pt-1">{globals.user.zof_pin}</span>
                            </div>
                        </div>
                    </div>

                    {/* Right column */}
                    <div className="space-y-5">
                        {/* Vstupní údaje */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-ruler text-green-500"></i>
                                {__('Vstupní údaje')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'inputData')}>?</a>
                            </h3>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Datum narození')}:</span>
                                <div className="flex gap-2 flex-wrap">
                                    <select className={selectCls + ' w-16'} name="birthday_day" defaultValue={profile.birthday_day} onChange={onChange}>
                                        {birthdayDays.map(d => <option key={d} value={d}>{d}</option>)}
                                    </select>
                                    <select className={selectCls + ' w-28'} name="birthday_month" defaultValue={profile.birthday_month} onChange={onChange}>
                                        {birthdayMonths.map((d, i) => <option key={i} value={(i + 1)}>{d}</option>)}
                                    </select>
                                    <select className={selectCls + ' w-20'} name="birthday_year" defaultValue={profile.birthday_year} onChange={onChange}>
                                        {birthdayYears.map(d => <option key={d} value={d}>{d}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Výška')}:</span>
                                <div className="flex items-center gap-2">
                                    <input className={inputShort} type="text" name="height" onChange={onChange} value={profile.height} />
                                    <span className="text-sm text-slate-500">cm</span>
                                </div>
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Váha')}:</span>
                                <div className="flex items-center gap-2">
                                    <input className={inputShort} type="text" name="weight" onChange={onChange} value={profile.weight} />
                                    <span className="text-sm text-slate-500">kg</span>
                                </div>
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Obvod pasu')}:</span>
                                <div className="flex items-center gap-2">
                                    <input className={inputShort} type="text" name="diameter_waist" onChange={onChange} value={profile.diameter_waist} />
                                    <span className="text-sm text-slate-500">cm</span>
                                </div>
                            </div>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>{__('Obvod boků')}:</span>
                                <div className="flex items-center gap-2">
                                    <input className={inputShort} type="text" name="diameter_sides" onChange={onChange} value={profile.diameter_sides} />
                                    <span className="text-sm text-slate-500">cm</span>
                                </div>
                            </div>
                        </div>

                        {/* BMR */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-heartbeat text-green-500"></i>
                                {__('Bazální metabolismus')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'bmr')}>?</a>
                            </h3>
                            <p className="text-sm text-slate-500 mb-3">{__('Pokud hodnotu neznáte, nevyplňujte, aplikace ji vypočítá sama.')}</p>
                            <div className={fieldRow}>
                                <span className={fieldLabel}>BMR:</span>
                                <div className="flex items-center gap-2">
                                    <input className={inputShort} type="text" name="individual_bmr" onChange={onChange} value={profile.individual_bmr} />
                                    <span className="text-sm text-slate-500">kcal</span>
                                </div>
                            </div>
                        </div>

                        {/* Energetický režim */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-bolt text-green-500"></i>
                                {__('Energetický režim')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'energeticRegime')}>?</a>
                            </h3>
                            <div className="space-y-2">
                                {energeticRegimes}
                            </div>
                        </div>

                        {/* Výdej energie */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-running text-green-500"></i>
                                {__('Výdej energie')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'energyOutput')}>?</a>
                            </h3>
                            <div className="space-y-2">
                                {energyOutputCoefficients}
                            </div>
                        </div>

                        {/* Stravovací režimy */}
                        <div className={card}>
                            <h3 className={sectionTitle}>
                                <i className="fa fa-leaf text-green-500"></i>
                                {__('Stravovací režimy')}
                                <a className={helpBtn} onClick={(e) => openHelp(e, 'nutritionRegime')}>?</a>
                                {vegeRegimesWarning && (
                                    <span className="ml-1 text-xs font-medium text-red-500 bg-red-50 border border-red-200 rounded-full px-2 py-0.5">
                                        Více než jeden vegetariánský profil!
                                    </span>
                                )}
                            </h3>
                            <div className="space-y-2">
                                {eatingRegimes}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Heslo - full width */}
                <div className={card}>
                    <h3 className={sectionTitle}>
                        <i className="fa fa-key text-green-500"></i>
                        {__('E-mail, změna hesla')}
                        <a className={helpBtn} onClick={(e) => openHelp(e, 'newPassword')}>?</a>
                    </h3>
                    <div className={fieldRow}>
                        <span className={fieldLabel}>{__('Přihlašovací e-mail')}:</span>
                        <span className="text-sm font-medium text-slate-700 pt-2">{globals.user.username}</span>
                    </div>
                    <p className="text-sm text-slate-400 mt-1 mb-3">{__('Pokud chcete ponechat stávající heslo, nechte pole prázdná.')}</p>
                    <div className={fieldRow}>
                        <span className={fieldLabel}>{__('Nové heslo')}:</span>
                        <div className="flex items-center gap-2 max-w-xs flex-1">
                            <input className={inputCls} type={newPasswordInputType} name="new_password" onChange={onChange} value={profile.new_password} />
                            <button type="button" onClick={toggleNewPasswordInputType} className="p-2 text-slate-400 hover:text-slate-600 transition-colors">
                                {newPasswordInputIcon}
                            </button>
                        </div>
                    </div>
                    <div className={fieldRow}>
                        <span className={fieldLabel}>{__('Nové heslo znovu')}:</span>
                        <div className="max-w-xs flex-1">
                            <input className={inputCls} type={newPasswordInputType} name="new_password_confirmation" onChange={onChange} value={profile.new_password_confirmation} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (tab === 'public') {
        const profileUrl = `https://zofapp.cz/u/id/${profile.user_id}`;

        content = (
            <div className="space-y-5">
                <div className="flex items-start gap-3 rounded-xl bg-amber-50 border border-amber-200 p-4">
                    <i className="fa fa-info-circle text-amber-500 text-lg mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-amber-800 leading-relaxed">Veřejné údaje slouží k vyplnění Vašeho veřejného profilu (pokud jej máte aktivován), který je umístěn na adrese <a href={profileUrl} className="underline">{profileUrl}</a></p>
                </div>
                <div className={card}>
                    <h3 className={sectionTitle}><i className="fa fa-user text-green-500"></i> Osobní údaje</h3>
                    {[['Jméno', 'name'], ['Datum narození', 'birthday'], ['Ulice', 'street'], ['Město', 'city'], ['PSČ', 'zip'], ['Země', 'country'], ['Telefon', 'phone'], ['Veřejný e-mail', 'public_email']].map(([label, name]) => (
                        <div key={name} className={fieldRow}>
                            <span className={fieldLabel}>{label}:</span>
                            <input className={inputCls} type="text" name={name} onChange={onChange} value={account[name] || ''} />
                        </div>
                    ))}
                    <div className={fieldRow}>
                        <span className={fieldLabel}>Více o mně:</span>
                        <textarea className={inputCls + ' h-32 resize-y'} name="description" onChange={onChange} value={account.description || ''}></textarea>
                    </div>
                </div>
                <div className={card}>
                    <h3 className={sectionTitle}><i className="fa fa-briefcase text-green-500"></i> Práce</h3>
                    {[['Kde pracujete?', 'workplace'], ['Odkaz', 'workplace_url'], ['Adresa', 'workplace_address']].map(([label, name]) => (
                        <div key={name} className={fieldRow}>
                            <span className={fieldLabel}>{label}:</span>
                            <input className={inputCls} type="text" name={name} onChange={onChange} value={account[name] || ''} />
                        </div>
                    ))}
                </div>
                <div className={card}>
                    <h3 className={sectionTitle}><i className="fa fa-share-alt text-green-500"></i> Sociální sítě</h3>
                    {[['Facebook', 'social_facebook'], ['Instagram', 'social_instagram'], ['YouTube', 'social_youtube'], ['Twitter', 'social_twitter'], ['LinkedIn', 'social_linkedin']].map(([label, name]) => (
                        <div key={name} className={fieldRow}>
                            <span className={fieldLabel}>{label}:</span>
                            <input className={inputCls} type="text" name={name} onChange={onChange} value={account[name] || ''} />
                        </div>
                    ))}
                </div>
                <div className={card}>
                    <h3 className={sectionTitle}><i className="fa fa-link text-green-500"></i> Adresa veřejného profilu</h3>
                    <div className={fieldRow}>
                        <span className={fieldLabel}>Adresa:</span>
                        <div className="flex-1">{publicProfileInput}</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full flex flex-col min-h-full bg-slate-50">
            {/* Page header */}
            <div className="bg-white border-b border-slate-200 px-6 py-5">
                <div className="max-w-5xl mx-auto flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white text-lg font-bold flex-shrink-0">
                        {profile.name ? profile.name.charAt(0).toUpperCase() : '?'}
                    </div>
                    <div>
                        <h1 className="text-xl font-bold text-slate-800 leading-tight">Nastavení profilu</h1>
                        {profile.name && <p className="text-sm text-slate-500">{profile.name}</p>}
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="bg-white border-b border-slate-200 px-6">
                <div className="max-w-5xl mx-auto flex gap-1">
                    <button
                        onClick={() => changeTab('basic')}
                        className={`px-5 py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === 'basic' ? 'border-green-500 text-green-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}`}
                    >
                        <i className="fa fa-sliders-h mr-2"></i>Základní údaje
                    </button>
                    <button
                        onClick={() => changeTab('public')}
                        className={`px-5 py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === 'public' ? 'border-green-500 text-green-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}`}
                    >
                        <i className="fa fa-globe mr-2"></i>Veřejný profil
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className="flex-1 px-4 py-6">
                <div className="max-w-5xl mx-auto">
                    {content}

                    {/* Save button */}
                    <div className="mt-6 pt-6 border-t border-slate-200 flex justify-center">
                        <button
                            onClick={saveProfile}
                            className="cursor-pointer bg-green-500 hover:bg-green-600 active:bg-green-700 text-white font-semibold px-10 py-3 rounded-xl transition-colors shadow-sm text-sm"
                        >
                            <i className="fa fa-save mr-2"></i>
                            {__('Uložit profil')}
                        </button>
                    </div>
                </div>
            </div>

            {savingEl}
        </div>
    );
}

export default UserEdit;
